import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteContentContext = createContext();

export const useSiteContent = () => {
  const context = useContext(SiteContentContext);
  if (!context) {
    throw new Error('useSiteContent must be used within a SiteContentProvider');
  }
  return context;
};

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [settings, setSettings] = useState({
    brand_name: 'mispedidos app',
    main_domain: 'mispedidosapp.com.ar',
    whatsapp_number: '3425149602',
    contact_email: 'mispedidosapp@gmail.com'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      // Cargar todas las páginas
      const pages = ['settings', 'home', 'soluciones', 'planes', 'demo'];
      const responses = await Promise.all(
        pages.map(page => 
          axios.get(`${API}/pages/${page}`).catch(() => ({ data: { content: null } }))
        )
      );

      const newContent = {};
      pages.forEach((page, i) => {
        if (responses[i].data?.content) {
          newContent[page] = responses[i].data.content;
        }
      });

      // Extraer settings si existe
      if (newContent.settings) {
        setSettings(newContent.settings);
      }

      setContent(newContent);
      setLoading(false);
    } catch (error) {
      console.error('Error loading site content:', error);
      setLoading(false);
    }
  };

  const getPageContent = (pageId) => {
    return content[pageId] || null;
  };

  const refreshContent = () => {
    loadContent();
  };

  return (
    <SiteContentContext.Provider
      value={{
        content,
        settings,
        loading,
        getPageContent,
        refreshContent
      }}
    >
      {children}
    </SiteContentContext.Provider>
  );
};
